import axios from '@/mod/axiosMod';

export default {
  getAuth() {
    return axios.get('/api/marketing/v1/source/merchant-ads-auth/show');
  },
  getPoi(pageNum = 1, pageSize = 50) {
    const params = { pageNum, pageSize };
    return axios.get('/api/marketing/v1/source/merchant-ads-auth/merchant-page', { params });
  },
  getData(dateRange = {}, poiId) {
    const params = { ...dateRange };
    if (poiId) {
      params.poiId = poiId;
    }
    return axios.get('/api/marketing/v1/source/merchant-ads-auth/data', { params });
  },
  getReferenceList(partnerId) {
    const params = {
      partnerId,
    };
    return axios.post('/apigw/api/kdb/poi/coop-reporter/list', params);
  },
  getReferenceDetail(partnerId, reportId) {
    const params = {
      partnerId,
      reportId,
    };
    return axios.post('/apigw/api/kdb/poi/coop-reporter/detail', params);
  },
  getTradeDataPoiList(poiName = '', startPage = 1, pageSize = 10) {
    const params = { startPage, pageSize };
    if (poiName) params.poiName = poiName;
    return axios.post('/apigw/api/kdb/partner/biz-poi-list', params);
  },
  getTradeData(poiId) {
    return axios.post('/apigw/api/kdb/partner/biz-poi-summary', { poiId });
  },

};
